import { ProductOrBrand } from "./alternativeTypes";

export const collaborationProducts: ProductOrBrand[] = [
  {
    name: "Teams",
    ownerCountry: "US",
    categories: ["collaboration", "video-meetings"],
  },
  {
    name: "Google Meet",
    ownerCountry: "US",
    categories: ["collaboration", "video-meetings"],
  },
  {
    name: "Slack",
    ownerCountry: "US",
    categories: ["collaboration", "collaboration-suite"],
  },
  {
    name: "Discord",
    ownerCountry: "US",
    categories: ["collaboration", "real-time-chat"],
  },
  {
    name: "Facebook Groups",
    ownerCountry: "US",
    categories: ["collaboration", "group-forum"],
  },
  {
    name: "Whereby",
    ownerCountry: "NO",
    categories: ["collaboration", "video-meetings"],
    sourceLinks: ["https://whereby.com"],
  },
  {
    name: "Whaller",
    ownerCountry: "FR",
    categories: ["collaboration", "collaboration-suite"],
    sourceLinks: ["https://whaller.com/"],
  },
  {
    name: "Revolt",
    ownerCountry: "UK",
    categories: ["collaboration", "real-time-chat", "collaboration-suite"],
    sourceLinks: ["https://revolt.chat/"],
  },
  {
    name: "Spond",
    ownerCountry: "NO",
    categories: ["collaboration", "group-forum"],
    sourceLinks: ["https://spond.com/"],
  },
];